export default __webpack_public_path__ + "static/banner-cc6a556dfd2f534a93b38fd270853b09.jpg";